import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchSharePatient'
})
export class SearchSharePatientPipe implements PipeTransform {

  transform(patData: any[], searchPatientTerm: string): any[] {
    if (!patData || !searchPatientTerm) { return patData; }

    patData.forEach(element => {
      if(element.doctorName==null ){
        element.doctorName="";
      }
      if(element.mobileNo==null ){
        element.mobileNo="";
      }
      if(element.emailId==null ){
        element.emailId="";
      }
    });
    return patData.filter(ad =>


      ad.fullName.toLowerCase().indexOf(searchPatientTerm.toLowerCase().trim()) !== -1 ||
      ad.patientId.toLowerCase().indexOf(searchPatientTerm.toLowerCase().trim()) !== -1 ||
      ad.doctorName.toLowerCase().indexOf(searchPatientTerm.toLowerCase().trim()) !== -1 ||
      ad.mobileNo.toLowerCase().indexOf(searchPatientTerm.toLowerCase().trim()) !== -1 ||
      ad.emailId.toLowerCase().indexOf(searchPatientTerm.toLowerCase().trim()) !== -1



    );
  }
}
